import { AtSignIcon, Button, EmptyState } from '@buffer-mono/popcorn'

import { FeedRow } from '../../components/FeedRow'
import { DEFAULT_STATUS } from '../../CommunityFilters/types'
import type { FilterStatus } from '../../CommunityFilters/types'

import type { JSX } from 'react'

type StatusMessage = {
  heading: string
  description: string
}

const STATUS_MESSAGES: Record<FilterStatus, StatusMessage> = {
  all: {
    heading: 'No mentions found',
    description: 'There are no mentions to display at this time.',
  },
  dismissed: {
    heading: "You haven't resolved any mentions yet.",
    description: 'This is where those mentions will appear.',
  },
  replied: {
    heading: "You haven't replied to any mentions yet.",
    description: 'This is where those mentions will appear.',
  },
  unreplied: {
    heading: 'No mentions found',
    description: 'There are no mentions to display at this time.',
  },
  new: {
    heading: 'No new mentions',
    description: 'There are no new mentions to display.',
  },
}

const FILTERED_MESSAGE: StatusMessage = {
  heading: 'No mentions found',
  description: 'There are no mentions meeting your filtering criteria.',
}

type NoMentionsFoundProps = {
  status?: FilterStatus
  hasActiveFilters: boolean
  onClearFilters: () => void
}

/**
 * Shown when the list is empty because of the active status filter or refined
 * filters, rather than because the channel has no mentions. Keeps the
 * listening and caught-up states from claiming something about the channel
 * that the filter, not the data, is responsible for.
 */
export const NoMentionsFound = ({
  status = DEFAULT_STATUS,
  hasActiveFilters,
  onClearFilters,
}: NoMentionsFoundProps): JSX.Element => {
  const message = hasActiveFilters ? FILTERED_MESSAGE : STATUS_MESSAGES[status]

  return (
    <FeedRow>
      <EmptyState size="large" variant="neutral">
        <EmptyState.Icon>
          <AtSignIcon />
        </EmptyState.Icon>
        <EmptyState.Heading>{message.heading}</EmptyState.Heading>
        <EmptyState.Description>{message.description}</EmptyState.Description>
        {hasActiveFilters && (
          <EmptyState.Actions>
            <Button size="large" onClick={onClearFilters}>
              Reset Filters
            </Button>
          </EmptyState.Actions>
        )}
      </EmptyState>
    </FeedRow>
  )
}
